export const APP_UNDO_CUSTOM_DRAFT_COMMAND = 'app-undo';
export const APP_REDO_CUSTOM_DRAFT_COMMAND = 'app-redo';
